import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  className?: string;
}
export function Button({
  children,
  className = '',
  ...props
}: ButtonProps) {
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`bg-terracotta hover:bg-terracotta-dark text-white font-bold py-4 px-8 rounded-full shadow-warm transition-colors duration-300 text-lg md:text-xl w-full md:w-auto ${className}`} {...props} data-id="element-121">
      {children}
    </motion.button>;
}